const ACTION_TYPES = {
    ADD_TOAST: 'ADD_TOAST',
    REMOVE_TOAST: 'REMOVE_TOAST',
} as const;

export { ACTION_TYPES };
